var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    fillRule: "nonzero",
    d: "M21.592 6.683c-.344-.453-.93-.805-1.555-.922-1.831-.348-13.266-.348-15.098 0-.5.094-.945.32-1.328.672C2 7.93 2.505 15.953 2.893 17.251c.164.564.375.97.64 1.235.344.352.812.595 1.352.703 1.51.311 9.284.486 15.122.047a2.617 2.617 0 0 0 1.39-.711c1.489-1.49 1.387-9.963.195-11.842zm-11.104 8.404V9.474c1.992.937 3.534 1.844 5.36 2.82-1.504.835-3.368 1.77-5.36 2.793z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3a1cb0ad4c688389d33b0b6949fdb731.svg";
export { ForwardRef as ReactComponent };